<div class="fixed bottom-3 end-3 z-10">
    <a [routerLink]="'/'" class="back-button size-8 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white rounded-md"><i data-feather="arrow-left" class="size-4"></i></a>
</div>
